/**
 * Frontend fallback for Timefold constraint labels. The human-readable catalog
 * (title/explanation/actionHint) is now produced server-side and shipped as ready strings on
 * the analyze result; this cleaner is only the last-resort fallback when the backend did not
 * attach a `localized` block (e.g. an old constraint not yet in the backend catalog).
 *
 * Der Solver liefert kanonische, sprachneutrale Keys als Constraint-Namen (z. B. `teacher0900`,
 * `class1002-hard`, `dep4001-hard`). Wir lösen sie über den geteilten Katalog
 * (@bp/shared-planung-utils) auf den deutschen Label auf; ist der Key unbekannt, fällt es auf den
 * Basis-Key (ohne Tier-Suffix) zurück.
 */

import { baseConstraintKey, constraintCatalogById } from '@bp/shared-planung-utils';

/** Bare key without a package prefix (`pkg/teacher0900` → `teacher0900`). */
function withoutPackage(rawLabel: string): string {
  return rawLabel.includes('/') ? (rawLabel.split('/').pop() ?? rawLabel) : rawLabel;
}

/** Human-readable fallback for a raw Timefold constraint label (= kanonischer Key). */
export function cleanConstraintLabel(rawLabel: string): string {
  const key = withoutPackage(rawLabel);
  return constraintCatalogById[key]?.label ?? baseConstraintKey(key);
}
